import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "privacy-policy__content" }
const _hoisted_2 = { class: "privacy-policy__content-heading" }
const _hoisted_3 = { class: "privacy-policy__content-items" }
const _hoisted_4 = { class: "content-item" }
const _hoisted_5 = { class: "content-item__text" }
const _hoisted_6 = { class: "content-item" }
const _hoisted_7 = { class: "content-item__heading" }
const _hoisted_8 = { class: "content-item__text" }
const _hoisted_9 = { class: "content-item__text" }
const _hoisted_10 = { class: "content-item__text" }
const _hoisted_11 = { class: "content-item__text" }
const _hoisted_12 = { class: "content-item__text" }
const _hoisted_13 = { class: "content-item__text" }
const _hoisted_14 = { class: "content-item__text" }
const _hoisted_15 = { class: "content-item__text" }
const _hoisted_16 = { class: "content-item__text" }
const _hoisted_17 = { class: "content-item" }
const _hoisted_18 = { class: "content-item__heading" }
const _hoisted_19 = { class: "content-item__text" }
const _hoisted_20 = { class: "content-item__list" }
const _hoisted_21 = { class: "list-item" }
const _hoisted_22 = { class: "list-item" }
const _hoisted_23 = { class: "list-item" }
const _hoisted_24 = { class: "list-item" }
const _hoisted_25 = { class: "list-item" }
const _hoisted_26 = { class: "list-item" }
const _hoisted_27 = { class: "list-item" }
const _hoisted_28 = { class: "content-item__text" }
const _hoisted_29 = { class: "content-item" }
const _hoisted_30 = { class: "content-item__heading" }
const _hoisted_31 = { class: "content-item__text" }
const _hoisted_32 = { class: "content-item__subtitle" }
const _hoisted_33 = { class: "content-item__text" }
const _hoisted_34 = { class: "content-item__subtitle" }
const _hoisted_35 = { class: "content-item__text" }
const _hoisted_36 = { class: "content-item__subtitle" }
const _hoisted_37 = { class: "content-item__text" }
const _hoisted_38 = { class: "content-item__subtitle" }
const _hoisted_39 = { class: "content-item__text" }
const _hoisted_40 = { class: "content-item__subtitle" }
const _hoisted_41 = { class: "content-item__text" }
const _hoisted_42 = { class: "content-item__subtitle" }
const _hoisted_43 = { class: "content-item__text" }
const _hoisted_44 = { class: "content-item__subtitle" }
const _hoisted_45 = { class: "content-item__text" }
const _hoisted_46 = { class: "content-item__subtitle" }
const _hoisted_47 = { class: "content-item__text" }
const _hoisted_48 = { class: "content-item__subtitle" }
const _hoisted_49 = { class: "content-item__text" }
const _hoisted_50 = { class: "content-item__list" }
const _hoisted_51 = { class: "list-item" }
const _hoisted_52 = { class: "list-item" }
const _hoisted_53 = { class: "content-item" }
const _hoisted_54 = { class: "content-item__heading" }
const _hoisted_55 = { class: "content-item__subtitle" }
const _hoisted_56 = { class: "content-item__text" }
const _hoisted_57 = { class: "content-item__subtitle" }
const _hoisted_58 = { class: "content-item__text" }
const _hoisted_59 = ["href"]
const _hoisted_60 = { class: "content-item__subtitle" }
const _hoisted_61 = { class: "content-item__text" }
const _hoisted_62 = ["href"]
const _hoisted_63 = { class: "content-item" }
const _hoisted_64 = { class: "content-item__heading" }
const _hoisted_65 = { class: "content-item__text" }
const _hoisted_66 = { class: "content-item" }
const _hoisted_67 = { class: "content-item__heading" }
const _hoisted_68 = { class: "content-item__text" }
const _hoisted_69 = { class: "content-item" }
const _hoisted_70 = { class: "content-item__heading" }
const _hoisted_71 = { class: "content-item__product-info" }
const _hoisted_72 = { class: "product-info__title" }
const _hoisted_73 = ["href"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "product-info__text" }, " U.K. ", -1)
const _hoisted_75 = { class: "content-item__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString($setup.PrivacyPolicyContent.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString($setup.PrivacyPolicyContent.appIsCommittedToProtect__text), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString($setup.PrivacyPolicyContent.personalData.title), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_1), 1),
        _createElementVNode("p", _hoisted_9, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_2), 1),
        _createElementVNode("p", _hoisted_10, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_3), 1),
        _createElementVNode("p", _hoisted_11, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_4), 1),
        _createElementVNode("p", _hoisted_12, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_5), 1),
        _createElementVNode("p", _hoisted_13, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_6), 1),
        _createElementVNode("p", _hoisted_14, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_7), 1),
        _createElementVNode("p", _hoisted_15, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_8), 1),
        _createElementVNode("p", _hoisted_16, _toDisplayString($setup.PrivacyPolicyContent.personalData.text.paragraph_9), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.title), 1),
        _createElementVNode("p", _hoisted_19, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.text.paragraph_1), 1),
        _createElementVNode("ul", _hoisted_20, [
          _createElementVNode("li", _hoisted_21, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.list.item_1), 1),
          _createElementVNode("li", _hoisted_22, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.list.item_2), 1),
          _createElementVNode("li", _hoisted_23, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.list.item_3), 1),
          _createElementVNode("li", _hoisted_24, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.list.item_4), 1),
          _createElementVNode("li", _hoisted_25, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.list.item_5), 1),
          _createElementVNode("li", _hoisted_26, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.list.item_6), 1),
          _createElementVNode("li", _hoisted_27, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.list.item_7), 1)
        ]),
        _createElementVNode("p", _hoisted_28, _toDisplayString($setup.PrivacyPolicyContent.purposeAndUseOfPersonalData.text.paragraph_2), 1)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("p", _hoisted_30, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.title), 1),
        _createElementVNode("p", _hoisted_31, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_1), 1),
        _createElementVNode("p", _hoisted_32, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_1), 1),
        _createElementVNode("p", _hoisted_33, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_2), 1),
        _createElementVNode("p", _hoisted_34, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_2), 1),
        _createElementVNode("p", _hoisted_35, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_3), 1),
        _createElementVNode("p", _hoisted_36, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_3), 1),
        _createElementVNode("p", _hoisted_37, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_4), 1),
        _createElementVNode("p", _hoisted_38, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_4), 1),
        _createElementVNode("p", _hoisted_39, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_5), 1),
        _createElementVNode("p", _hoisted_40, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_5), 1),
        _createElementVNode("p", _hoisted_41, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_6), 1),
        _createElementVNode("p", _hoisted_42, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_6), 1),
        _createElementVNode("p", _hoisted_43, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_7), 1),
        _createElementVNode("p", _hoisted_44, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_7), 1),
        _createElementVNode("p", _hoisted_45, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_8), 1),
        _createElementVNode("p", _hoisted_46, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_8), 1),
        _createElementVNode("p", _hoisted_47, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_9), 1),
        _createElementVNode("p", _hoisted_48, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.subtitle_9), 1),
        _createElementVNode("p", _hoisted_49, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.text.paragraph_10), 1),
        _createElementVNode("ul", _hoisted_50, [
          _createElementVNode("li", _hoisted_51, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.list.item_1), 1),
          _createElementVNode("li", _hoisted_52, _toDisplayString($setup.PrivacyPolicyContent.sharePersonalData.list.item_2), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("p", _hoisted_54, _toDisplayString($setup.PrivacyPolicyContent.yourRights.title), 1),
        _createElementVNode("p", _hoisted_55, _toDisplayString($setup.PrivacyPolicyContent.yourRights.text.subtitle_1), 1),
        _createElementVNode("p", _hoisted_56, _toDisplayString($setup.PrivacyPolicyContent.yourRights.text.paragraph_1), 1),
        _createElementVNode("p", _hoisted_57, _toDisplayString($setup.PrivacyPolicyContent.yourRights.text.subtitle_2), 1),
        _createElementVNode("p", _hoisted_58, [
          _createTextVNode(" By being an active and existing customer of Customis3d, we have a legitimate interest in marketing our products for you. You can unsubscribe to this kind of communication in your customer Account or at any time by following the unsubscribe instructions in the communication sent to you or by contacting us at "),
          _createElementVNode("a", {
            href: `mailto:${$setup.ProductInfo.Email}`,
            class: "content-item__text-link"
          }, _toDisplayString($setup.ProductInfo.Email), 9, _hoisted_59),
          _createTextVNode(". Despite your indicated opt-out preferences, we may continue to send you administrative and transaction-related communications. ")
        ]),
        _createElementVNode("p", _hoisted_60, _toDisplayString($setup.PrivacyPolicyContent.yourRights.text.subtitle_3), 1),
        _createElementVNode("p", _hoisted_61, [
          _createTextVNode(" We delete Your Personal Data once no longer necessary for the purposes for which they were collected or otherwise processed. You may access, review, update, correct or delete the Personal Data in your Account either by using the Account buttons or by contacting us directly using the contact information provided below. If you want to have your personal data transferred to someone else, please e-mail us at "),
          _createElementVNode("a", {
            href: `mailto:${$setup.ProductInfo.Email}`,
            class: "content-item__text-link"
          }, _toDisplayString($setup.ProductInfo.Email), 9, _hoisted_62),
          _createTextVNode(", and we will provide you with your data file. If you completely delete all of your Personal Data, your Account will become deactivated. If you want us to delete your data, please contact us, and we will fulfil your request. ")
        ])
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("p", _hoisted_64, _toDisplayString($setup.PrivacyPolicyContent.dataControllersAndProcessors.title), 1),
        _createElementVNode("p", _hoisted_65, _toDisplayString($setup.PrivacyPolicyContent.dataControllersAndProcessors.text), 1)
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("p", _hoisted_67, _toDisplayString($setup.PrivacyPolicyContent.changesToPrivacyPolicy.title), 1),
        _createElementVNode("p", _hoisted_68, _toDisplayString($setup.PrivacyPolicyContent.changesToPrivacyPolicy.text), 1)
      ]),
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("p", _hoisted_70, _toDisplayString($setup.PrivacyPolicyContent.dataProtectionOfficer.title), 1),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("p", _hoisted_72, _toDisplayString($setup.ProductInfo.CompanyName), 1),
          _createElementVNode("a", {
            href: `mailto:${$setup.ProductInfo.Email}`,
            class: "content-item__text-link"
          }, _toDisplayString($setup.ProductInfo.Email), 9, _hoisted_73),
          _hoisted_74
        ]),
        _createElementVNode("p", _hoisted_75, _toDisplayString($setup.PrivacyPolicyContent.dataProtectionOfficer.text), 1)
      ])
    ])
  ]))
}